import { handleActions } from 'redux-actions'
import { oc } from 'ts-optchain'

import {
  DEBIT_CARD_DESIGN_EZL,
  DEBIT_CARD_DESIGN_LIST,
  DEBIT_CARD_DESIGN_LIST_V2,
  IDebitCardType,
} from '@/domains/DebitCardDomain'
import { IRootState } from '@/modules'
import { debitCardIssueSelector } from '@/modules/debit-card/DebitCardIssueModule'

export const DEBIT_CARD_ISSUE_DESIGN = 'DebitCardIssueDesign'


export const initialState = {
  debitCardDesignList: DEBIT_CARD_DESIGN_LIST,
  debitCardDesignListV2: DEBIT_CARD_DESIGN_LIST_V2,
}

export const debitCardIssueDesignSelector = {
  cardTypes: (state: IRootState) => {
    const cardTypes = oc(state[DEBIT_CARD_ISSUE_DESIGN]).debitCardDesignList([])
    // const { isReissue } = debitCardIssueSelector.mode(state)
    // const { selectedCardType } = debitCardIssueSelector.view(state)

    // if (!isReissue) {
    return cardTypes
    // }

    // return cardTypes.filter(({ debitCardDesignTypeCode: no }) => selectedCardType !== no)
  },
  cardTypes2: (state: IRootState) => {
    const cardTypes2 = oc(state[DEBIT_CARD_ISSUE_DESIGN]).debitCardDesignListV2([])

    return cardTypes2
  },
  selectedCardType: (state: IRootState): IDebitCardType => {
    const { isEZL } = debitCardIssueSelector.mode(state)
    if (isEZL) {
      // design 화면에도 EZL 카드 노출되는 것을 막기 위해 DEBIT_CARD_DESIGN_LIST 에 추가 x
      return DEBIT_CARD_DESIGN_EZL
    }

    const { selectedCardType } = debitCardIssueSelector.view(state)
    // const result = oc(state[DEBIT_CARD_ISSUE_DESIGN])
    //   .debitCardDesignList([])
    //   .find((design: IDebitCardType) =>
    //     design.debitCardDesignTypeCode === selectedCardType
    //   )

    const result = oc(state[DEBIT_CARD_ISSUE_DESIGN])
      .debitCardDesignListV2([])
      .find((design: IDebitCardType) => design.debitCardDesignTypeCode === selectedCardType)

    if (!result) {
      return DEBIT_CARD_DESIGN_LIST[0]
    }

    return result
  },
}

export const debitCardIssueDesignReducer = handleActions({}, initialState)
